import React, { useState } from 'react';
import { Menu, X, ChevronDown } from 'lucide-react';
import { WA_NUMBER } from '../data/products';
interface NavbarProps {
  onBrandFilter?: (brand: string | null) => void;
}
export function Navbar({
  onBrandFilter
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isBrandsOpen, setIsBrandsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => {
    setIsOpen(false);
    setIsBrandsOpen(false);
  };
  const handleBrandClick = (brand: string) => {
    if (onBrandFilter) {
      onBrandFilter(brand);
    }
    closeMenu();
    // Smooth scroll to products section
    setTimeout(() => {
      const productsSection = document.getElementById('productos');
      if (productsSection) {
        productsSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }, 100);
  };
  const navLinks = [{
    href: '#productos',
    label: 'Productos'
  }, {
    href: '#combos',
    label: 'Combos'
  }, {
    href: '#nosotros',
    label: 'Nosotros'
  }, {
    href: '#faq',
    label: 'FAQ'
  }, {
    href: '#envios',
    label: 'Envíos'
  }, {
    href: '#ubicacion',
    label: 'Ubicación'
  }, {
    href: `https://wa.me/${WA_NUMBER}`,
    label: 'WhatsApp',
    external: true
  }];
  return <nav className="bg-dark-700 border-b-2 border-alphaGold py-4 px-5 relative z-50" data-id="element-202" data-mp="oje1uppz9jh9">
      <div className="max-w-[1100px] mx-auto flex justify-between items-center" data-id="element-203" data-mp="3n19ifjt379pv">
        <a href="#" className="flex items-center" onClick={closeMenu} data-id="element-204" data-mp="3s2ytv0k81peh">
          <img src="https://cdn.magicpatterns.com/uploads/o9QuWRFj9QDHop4MmMKe7L/Logo_-_Editado.png" alt="AlphaFit" className="h-8 md:h-10 object-contain" onError={e => {
          // Fallback to text if logo is missing
          e.currentTarget.style.display = 'none';
          e.currentTarget.nextElementSibling?.classList.remove('hidden');
        }} data-id="element-205" data-mp="vw1i5sndd2o" />
          <span className="hidden text-2xl font-black text-alphaGold tracking-[3px] uppercase" data-id="element-206" data-mp="319ovmfov4wyu">
            Alpha<span className="text-white" data-id="element-207" data-mp="2wbwwp1pswal5">Fit</span>
          </span>
        </a>

        {/* Desktop Menu */}
        <ul className="hidden md:flex items-center gap-6 list-none" data-id="element-208" data-mp="3b35sjskaqs6q">
          <li data-id="element-209" data-mp="363b2tsc9c8n9">
            <a href="#ofertas" className="inline-flex items-center gap-1.5 bg-[#ff3b30] text-white no-underline text-[0.85rem] font-black tracking-wide uppercase px-3.5 py-1.5 rounded-full transition-all duration-300 hover:bg-[#e0271d] hover:scale-105 shadow-[0_0_15px_rgba(255,59,48,0.4)] animate-pulse" data-id="element-210" data-mp="362i155s5o9bz">
              ¡Ofertas!
            </a>
          </li>
          <li data-id="element-211" data-mp="2na74vus0b9mu">
            <a href="#productos" onClick={() => onBrandFilter && onBrandFilter(null)} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-212" data-mp="2ndl5oyl0vas6">
              Productos
            </a>
          </li>

          {/* Marcas Dropdown Desktop */}
          <li className="relative group" data-id="element-213" data-mp="f5gb8suuw48c">
            <button className="flex items-center gap-1 text-[#ddd] text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-214" data-mp="14dosezy8rww">
              Marcas{' '}
              <ChevronDown size={16} className="transition-transform group-hover:rotate-180" data-id="element-215" data-mp="svjr923571pc" />
            </button>
            <div className="absolute top-full left-0 w-48 bg-dark-700 border border-dark-500 rounded-md shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 translate-y-2 group-hover:translate-y-0 overflow-hidden" data-id="element-216" data-mp="xwhazj3sw3sy">
              <button onClick={() => handleBrandClick('Cibeles')} className="w-full text-left px-4 py-3 text-white hover:bg-dark-600 hover:text-alphaGold transition-colors border-b border-dark-500 font-medium" data-id="element-217" data-mp="1bt34yj0jp8i3">
                Cibeles
              </button>
              <button onClick={() => handleBrandClick('Profit')} className="w-full text-left px-4 py-3 text-white hover:bg-dark-600 hover:text-alphaGold transition-colors font-medium" data-id="element-218" data-mp="3k22n34efg6q6">
                Profit
              </button>
            </div>
          </li>

          {navLinks.slice(1).map(link => <li key={link.label} data-id="element-219" data-mp="6o7n43irctx4">
              <a href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} className="text-[#ddd] no-underline text-[0.9rem] font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold" data-id="element-220" data-mp="6oz8ymmjzda7">
                {link.label}
              </a>
            </li>)}
        </ul>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white p-2 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-221" data-mp="289tm95swi0v2">
          {isOpen ? <X size={28} data-id="element-222" data-mp="2dar2vdy9imug" /> : <Menu size={28} data-id="element-223" data-mp="2ha87y69s1hz3" />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && <div className="md:hidden absolute top-full left-0 w-full bg-dark-700 border-b border-dark-400 shadow-xl py-4 px-5 flex flex-col gap-2" data-id="element-224" data-mp="2m93224d72syi">
          <a href="#ofertas" onClick={closeMenu} className="text-white no-underline text-lg font-black tracking-wide uppercase bg-[#ff3b30] text-center py-2.5 rounded-lg mb-1 shadow-[0_0_15px_rgba(255,59,48,0.4)] hover:bg-[#e0271d] transition-colors" data-id="element-225" data-mp="2r7wedtgqwdx3">
            ¡Ofertas Imperdibles!
          </a>
          <a href="#productos" onClick={e => {
        if (onBrandFilter) onBrandFilter(null);
        closeMenu();
      }} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500" data-id="element-226" data-mp="39z5oo4ycb6pq">
            Productos
          </a>

          {/* Marcas Accordion Mobile */}
          <div className="border-b border-dark-500" data-id="element-227" data-mp="1omc3vsvaf1kd">
            <button onClick={() => setIsBrandsOpen(!isBrandsOpen)} className="w-full flex items-center justify-between text-[#ddd] text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold py-2" data-id="element-228" data-mp="1juty8ribkct2">
              Marcas
              <ChevronDown size={20} className={`transition-transform duration-300 ${isBrandsOpen ? 'rotate-180' : ''}`} data-id="element-229" data-mp="27keolvgsyccd" />
            </button>

            <div className={`overflow-hidden transition-all duration-300 ${isBrandsOpen ? 'max-h-40 opacity-100 mb-2' : 'max-h-0 opacity-0'}`} data-id="element-230" data-mp="22jif92dolxzk">
              <button onClick={() => handleBrandClick('Cibeles')} className="w-full text-left pl-4 py-2 text-[#aaa] hover:text-alphaGold transition-colors text-base font-medium" data-id="element-231" data-mp="8954h14t556t">
                • Cibeles
              </button>
              <button onClick={() => handleBrandClick('Profit')} className="w-full text-left pl-4 py-2 text-[#aaa] hover:text-alphaGold transition-colors text-base font-medium" data-id="element-232" data-mp="2a3t194iuqr8g">
                • Profit
              </button>
            </div>
          </div>

          {navLinks.slice(1).map(link => <a key={link.label} href={link.href} target={link.external ? '_blank' : '_self'} rel={link.external ? 'noopener noreferrer' : ''} onClick={closeMenu} className="text-[#ddd] no-underline text-lg font-semibold tracking-wide uppercase transition-colors duration-300 hover:text-alphaGold block py-2 border-b border-dark-500 last:border-0" data-id="element-233" data-mp="1r601gb3iyxfa">
              {link.label}
            </a>)}
        </div>}
    </nav>;
}